<template>
  <div class="reports pb-lg-0 pb-8">
    <!-- <div class="page-header text-center c-grey fs-large">
      <p class="mb-1 px-2">
        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ
      </p>
      <p>و با استفاده از طراحان گرافیک است.</p>
    </div> -->
    <v-row dir="ltr" class="main-content px-md-10 pb-4 pt-4">
      <v-col lg="4" md="4" sm="4" cols="12">
        <router-link to="/admin/catReport" class="no-underline">
          <v-card class="common-card card-height me-auto" flat>
            <div class="image-box">
              <img src="/cat report.png" />
            </div>
            <div class="text-center mt-10">
              <p class="fs-xlarge c-dark font-weight-bold">گزارش موضوعات</p>
              <p class="fs-medium c-grey mb-0 mt-6">
                در این بخش می‌توانید با انتخاب موضوعات، دانشگاه‌های فعال و کلان
                پروژه‌های مربوطه را مشاهده نمایید.
              </p>
            </div>
          </v-card>
        </router-link>
      </v-col>
      <v-col lg="4" md="4" sm="4" cols="12">
        <router-link to="/admin/uniRequestReport" class="no-underline">
          <v-card class="common-card card-height me-auto" flat>
            <div class="image-box">
              <img src="/uniRequest report.jpg" />
            </div>
            <div class="text-center mt-10">
              <p class="fs-xlarge c-dark font-weight-bold">
                گزارش طرح‌های کلان
              </p>
              <p class="fs-medium c-grey mb-0 mt-6">
                در این بخش می‌توانید با انتخاب دانشگاه‌(ها) نسبت به دریافت گزارش
                از موضوعات فعالیت و طرح‌های کلان اقدام نمایید
              </p>
            </div>
          </v-card>
        </router-link>
      </v-col>
      <v-col lg="4" md="4" sm="4" cols="12">
        <router-link to="/admin/universityReport" class="no-underline">
          <v-card class="common-card card-height me-auto" flat>
            <div class="image-box">
              <img src="/uniReport.jpg" />
            </div>
            <div class="text-center mt-10">
              <p class="fs-xlarge c-dark font-weight-bold">گزارش دانشگاه‌ها</p>
              <p class="fs-medium c-grey mb-0 mt-6">
                در این بخش با انتخاب استان(ها) و دانشگاه(های) مربوطه می‌توانید
                گزارش درخواست‌های ثبت شده برای این موارد را تولید و مشاهده
                نمایید
              </p>
            </div>
          </v-card>
        </router-link>
      </v-col>
      <v-col lg="4" md="4" sm="4" cols="12">
        <router-link to="/admin/personalReport" class="no-underline">
          <v-card class="common-card card-height" flat>
            <div class="image-box">
              <img src="/personalReport.png" />
            </div>
            <div class="text-center mt-10">
              <p class="fs-xlarge c-dark font-weight-bold">گزارش فردی</p>
              <p class="fs-medium c-grey mb-0 mt-6">
                در این بخش می‌توانید از بین کاربران پژوهشگر و یا داوران، یک فرد
                را انتخاب کرده و گزارشی از عملکرد ایشان مشاهده نمایید
              </p>
            </div>
          </v-card>
        </router-link>
      </v-col>
      <v-col lg="4" md="4" sm="4" cols="12">
        <router-link to="/admin/requestsReport" class="no-underline">
          <v-card class="common-card card-height me-auto" flat>
            <div class="image-box">
              <img src="/requestsReport.png" />
            </div>
            <div class="text-center mt-10">
              <p class="fs-xlarge c-dark font-weight-bold">
                گزارش محور و حمایت‌ها
              </p>
              <p class="fs-medium c-grey mb-0 mt-6">
                در این بخش می‌توانید از طریق انتخاب نوع حمایت و محور(های) مورد
                نظر، گزارش مربوطه را تولید و مشاهده نمایید
              </p>
            </div>
          </v-card>
        </router-link>
      </v-col>
      <v-col lg="4" md="4" sm="4" cols="12">
        <router-link to="/admin/acceleratorReport" class="no-underline">
          <v-card class="common-card card-height" flat>
            <div class="image-box">
              <img
                src="https://cdn.lynda.com/course/157341/157341-636283001243114363-16x9.jpg"
              />
            </div>
            <div class="text-center mt-10">
              <p class="fs-xlarge c-dark font-weight-bold">
                گزارش شتاب‌دهنده‌ها
              </p>
              <p class="fs-medium c-grey mb-0 mt-6">
                در این بخش می‌توانید از طریق انتخاب شتاب‌دهنده(های) مورد نظر،
                گزارش مربوطه را تولید و مشاهده نمایید
              </p>
            </div>
          </v-card>
        </router-link>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  //mounted() {
  //  if (
  //    !document.body.classList.contains("sidebar-minimized") &&
  //    !document.body.classList.contains("brand-minimized")
  //  ) {
  //    document.body.classList.add("sidebar-minimized");
  //    document.body.classList.add("brand-minimized");
  //    this.toast(
  //      "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
  //    );
  //  }
  //},
};
</script>

<style lang="scss">
.reports {
  background-image: url("/Light_blue.png");
  background-size: cover;
  min-height: calc(100vh - 200px) !important;
  border-radius: 7px;
  &::-webkit-scrollbar {
    display: none;
  }
}

.main-content {
  background-image: url("/Light_blue.png");
  background-size: cover;
  margin: 0 20px;
}
</style>
